import { Entity, Field } from "typegraph";

import { Entry } from "./Entry";

@Entity({one: "programTrackProduct", many: "programTrackProducts"})
export default class ProgramTrackProduct {

	@Field()
	public id: number;

	@Field({entity: Entry})
	public entry: Entry; // entry has Subscription and Product.

}



// WEBPACK FOOTER //
// ./src/panels/program/entities/ProgramTrackProduct.ts